import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ads-page-header d-md-flex align-items-center justify-content-between mb-20" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "ms-12" }
const _hoisted_4 = { class: "mb-0 text-muted fs-13" }
const _hoisted_5 = { class: "card ads-card mb-25 border-0 letter-spacing" }
const _hoisted_6 = { class: "ads-filters row align-items-end g-10 p-15 p-sm-20 p-md-25 pb-0" }
const _hoisted_7 = { class: "col-md-4 mb-3" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "col-md-4 text-md-end mb-3" }
const _hoisted_10 = { class: "card-head d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "d-sm-flex align-items-center" }
const _hoisted_12 = { class: "ads-search position-relative" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25 pt-0" }
const _hoisted_14 = {
  key: 0,
  class: "skeleton-table w-100"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "status-pill status-pill-warning"
}
const _hoisted_18 = {
  key: 1,
  class: "status-pill status-pill-info"
}
const _hoisted_19 = {
  key: 2,
  class: "status-pill status-pill-primary"
}
const _hoisted_20 = {
  key: 3,
  class: "status-pill status-pill-success"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = { key: 7 }
const _hoisted_28 = { style: {"color":"#f08016"} }
const _hoisted_29 = { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 8 }
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = { class: "dropdown-menu" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 2 }
const _hoisted_40 = ["href"]
const _hoisted_41 = { key: 9 }
const _hoisted_42 = {
  class: "modal fade",
  id: "chatClaimModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "modal-dialog modal-xl" }
const _hoisted_44 = { class: "modal-content ads-modal-content" }
const _hoisted_45 = { class: "modal-body" }
const _hoisted_46 = {
  class: "modal fade",
  id: "infosClaimModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-lg" }
const _hoisted_48 = { class: "modal-content ads-modal-content" }
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = { class: "form-group mb-3" }
const _hoisted_51 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_52 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_53 = {
  key: 2,
  class: "form-group mb-3"
}
const _hoisted_54 = {
  key: 3,
  class: "form-group mb-3"
}
const _hoisted_55 = {
  key: 4,
  class: "form-group mb-3"
}
const _hoisted_56 = {
  key: 5,
  class: "form-group mb-3"
}
const _hoisted_57 = { class: "form-group mb-3" }
const _hoisted_58 = { class: "form-group mb-3" }
const _hoisted_59 = { class: "modal-footer ads-modal-footer" }
const _hoisted_60 = {
  class: "modal fade",
  id: "chnageObjectClaimModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-xl" }
const _hoisted_62 = { class: "modal-content ads-modal-content" }
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = { class: "form-group mb-3" }
const _hoisted_65 = ["value"]
const _hoisted_66 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_67 = { class: "form-group mb-3" }
const _hoisted_68 = { class: "form-group mb-3" }
const _hoisted_69 = { class: "form-group mb-3" }
const _hoisted_70 = { class: "form-group mb-3" }
const _hoisted_71 = { class: "modal-footer ads-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_ChatClaim = _resolveComponent("ChatClaim")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ads-page-icon" }, [
          _createElementVNode("i", { class: "ph ph-warning-circle" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "mb-0 fw-bold" }, "Gestion des réclamations", -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.users.total || _ctx.rows.length) + " réclamation" + _toDisplayString((_ctx.users.total || _ctx.rows.length) > 1 ? "s" : "") + " au total ", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "fw-medium mb-10 d-block" }, "Statut", -1)),
          _createVNode(_component_v_select, {
            label: "name",
            options: _ctx.objectsClaim,
            modelValue: _ctx.object_filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.object_filter) = $event))
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "fw-medium mb-10 d-block" }, "Client", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.customer_filter,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer_filter) = $event)),
            label: "name",
            options: _ctx.clientList,
            placeholder: "Client (Tous)",
            onSearch: _ctx.filterClients
          }, {
            "no-options": _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("Taper un mot pour chercher un client", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "options", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "ads-btn-primary border-0 transition fw-medium me-2",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, _cache[32] || (_cache[32] = [
            _createElementVNode("i", { class: "flaticon-filter me-1" }, null, -1),
            _createTextVNode(" Filtrer ", -1)
          ])),
          _createElementVNode("button", {
            class: "ads-btn-outline transition fw-medium",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
          }, _cache[33] || (_cache[33] = [
            _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
            _createTextVNode(" Annuler ", -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "ads-btn-outline position-relative transition fw-medium d-inline-flex align-items-center mb-10 mb-lg-0",
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportClaims()))
          }, _cache[34] || (_cache[34] = [
            _createElementVNode("i", { class: "flaticon-file-1 position-relative fs-15 me-8" }, null, -1),
            _createTextVNode(" Export ", -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-search ads-search-icon" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control ps-40",
            placeholder: "Rechercher une réclamation...",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "loading-spinner-wrap text-center py-15" }, [
                _createElementVNode("div", {
                  class: "spinner-border text-success",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ])
              ], -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createElementVNode("div", {
                  class: "skeleton-row d-flex align-items-center",
                  key: n
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers.length, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "skeleton-cell",
                      key: c
                    }, _cache[36] || (_cache[36] = [
                      _createElementVNode("span", { class: "skeleton-bar" }, null, -1)
                    ])))
                  }), 128))
                ])
              }), 64))
            ]))
          : (_openBlock(), _createBlock(_component_vue_good_table, {
              key: 1,
              class: "ads-good-table",
              columns: _ctx.headers,
              rows: _ctx.rows
            }, {
              emptystate: _withCtx(() => _cache[38] || (_cache[38] = [
                _createElementVNode("div", { class: "empty-state text-center py-40" }, [
                  _createElementVNode("i", { class: "ph ph-warning-circle fs-40 d-block mb-10 text-muted" }),
                  _createElementVNode("p", { class: "mb-0 text-muted" }, "Aucune entrées correspondantes trouvées")
                ], -1)
              ])),
              "table-row": _withCtx((props) => [
                (props.column.field == 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                  : (props.column.field === 'statut')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        (props.row.statut == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _cache[39] || (_cache[39] = [
                              _createElementVNode("span", { class: "status-pill-dot" }, null, -1),
                              _createTextVNode(" En cours de traitement ", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (props.row.statut == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[40] || (_cache[40] = [
                              _createElementVNode("span", { class: "status-pill-dot" }, null, -1),
                              _createTextVNode(" Réponse service ", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (props.row.statut == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[41] || (_cache[41] = [
                              _createElementVNode("span", { class: "status-pill-dot" }, null, -1),
                              _createTextVNode(" Réponse client ", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (props.row.statut == 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _cache[42] || (_cache[42] = [
                              _createElementVNode("span", { class: "status-pill-dot" }, null, -1),
                              _createTextVNode(" Réclamation traitée ", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field === 'name')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          _createElementVNode("a", {
                            onClick: _withModifiers(($event: any) => (
                _ctx.$router.push({
                  name: 'EditCustomerPage',
                  params: { id: props.row.customer_id },
                })
              ), ["prevent"]),
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);"
                          }, _toDisplayString(props.row.client?.store), 9, _hoisted_22)
                        ]))
                      : (props.column.field === 'city')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(props.row.city?.city), 1))
                        : (props.column.field === 'created_at')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _createElementVNode("h5", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                              (props.row.taken_by_name && props.row.taken_by_name != '')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[43] || (_cache[43] = _createTextVNode(" Pris par: ", -1)),
                                    _createElementVNode("span", null, _toDisplayString(props.row.taken_by_name), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : (props.column.field === 'last_response_by_name')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createTextVNode(_toDisplayString(props.row.last_response_by_name), 1),
                                _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("small", null, _toDisplayString(_ctx.getDate(props.row.response_time)), 1)
                              ]))
                            : (props.column.field === 'code_colis')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.row.code_colis), 1))
                              : (props.column.field === 'object')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.object), 1),
                                    _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("small", _hoisted_28, [
                                      _createTextVNode(_toDisplayString(props.row.code_colis) + " ", 1),
                                      (props.row.new_price)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[45] || (_cache[45] = _createTextVNode(" - ", -1)),
                                            _createElementVNode("b", null, _toDisplayString(props.row.new_price) + " " + _toDisplayString(_ctx.settingData[0]?.devis), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (props.row.new_price_remb)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[46] || (_cache[46] = _createTextVNode(" - ", -1)),
                                            _createElementVNode("b", null, _toDisplayString(props.row.new_price_remb) + " " + _toDisplayString(_ctx.settingData[0]?.devis), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("button", {
                                        class: "bg-transparent p-0 border-0 text-black transition lh-1",
                                        onClick: ($event: any) => (_ctx.showObject(props.row))
                                      }, _cache[47] || (_cache[47] = [
                                        _createElementVNode("i", { class: "ph-duotone ph-pen" }, null, -1)
                                      ]), 8, _hoisted_30)
                                    ])
                                  ]))
                                : (props.column.field === 'action')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _cache[53] || (_cache[53] = _createElementVNode("button", {
                                          class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                          type: "button",
                                          "data-bs-toggle": "dropdown",
                                          "aria-expanded": "false"
                                        }, [
                                          _createElementVNode("i", { class: "flaticon-dots" })
                                        ], -1)),
                                        _createElementVNode("ul", _hoisted_33, [
                                          _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item d-flex align-items-center",
                                              href: "javascript:void(0);",
                                              onClick: _withModifiers(($event: any) => (_ctx.showUpdate(props.row)), ["prevent"])
                                            }, _cache[49] || (_cache[49] = [
                                              _createElementVNode("i", { class: "ph ph-chat-circle-dots lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Conversation ", -1)
                                            ]), 8, _hoisted_34)
                                          ]),
                                          (props.row.statut !== 3 && props.row.statut !== 4)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                                _createElementVNode("a", {
                                                  class: "dropdown-item d-flex align-items-center",
                                                  href: "javascript:void(0);",
                                                  onClick: ($event: any) => (_ctx.processedClaim(props.row))
                                                }, _cache[50] || (_cache[50] = [
                                                  _createElementVNode("i", { class: "ph ph-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" En cours de traitement ", -1)
                                                ]), 8, _hoisted_36)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (props.row.statut !== 3)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                                                _createElementVNode("a", {
                                                  class: "dropdown-item d-flex align-items-center",
                                                  href: "javascript:void(0);",
                                                  onClick: ($event: any) => (_ctx.showDetails(props.row))
                                                }, _cache[51] || (_cache[51] = [
                                                  _createElementVNode("i", { class: "ph ph-check-circle lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" Traiter la réclamation ", -1)
                                                ]), 8, _hoisted_38)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (props.row.city?.lien)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                                                _createElementVNode("a", {
                                                  class: "dropdown-item d-flex align-items-center",
                                                  href: props.row.city?.lien,
                                                  target: "_blank"
                                                }, _cache[52] || (_cache[52] = [
                                                  _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" Groupe Whatsapp ", -1)
                                                ]), 8, _hoisted_40)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"])),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.fetchData
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _cache[54] || (_cache[54] = _createStaticVNode("<div class=\"modal-header ads-modal-header\" data-v-9a73b940><div class=\"d-flex align-items-center\" data-v-9a73b940><span class=\"ads-modal-icon\" data-v-9a73b940><i class=\"ph ph-chat-circle-dots\" data-v-9a73b940></i></span><h5 class=\"modal-title ms-12 mb-0\" data-v-9a73b940>Conversation réclamation</h5></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-9a73b940></button></div>", 1)),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_ChatClaim, {
              messages: _ctx.chatMsgs,
              fetchMessages: _ctx.fetchMessages,
              rowClaim: _ctx.showClaim
            }, null, 8, ["messages", "fetchMessages", "rowClaim"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _cache[67] || (_cache[67] = _createStaticVNode("<div class=\"modal-header ads-modal-header\" data-v-9a73b940><div class=\"d-flex align-items-center\" data-v-9a73b940><span class=\"ads-modal-icon\" data-v-9a73b940><i class=\"ph ph-check-circle\" data-v-9a73b940></i></span><h5 class=\"modal-title ms-12 mb-0\" data-v-9a73b940>Informations réclamation</h5></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-9a73b940></button></div>", 1)),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.traitClaim && _ctx.traitClaim(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_50, [
                _cache[55] || (_cache[55] = _createElementVNode("label", { for: "object" }, "Object", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "object",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formClaim.object) = $event)),
                  disabled: "",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.formClaim.object]
                ])
              ]),
              _cache[65] || (_cache[65] = _createElementVNode("hr", null, null, -1)),
              (
                [
                  'Changement de prix',
                  'Relance Colis/Client',
                  'Annulation Colis',
                ].includes(_ctx.formClaim.object)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _cache[56] || (_cache[56] = _createElementVNode("label", { for: "colis" }, "Colis", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "colis",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formClaim.code_colis) = $event)),
                      disabled: "",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.code_colis]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formClaim.object === 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", null, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { for: "colis" }, "Colis", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "colis",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formClaim.code_colis) = $event)),
                        disabled: "",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formClaim.code_colis]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formClaim.object === 'Changement de prix')
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _cache[58] || (_cache[58] = _createElementVNode("label", { for: "price" }, "Nouveau Prix", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "price",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formClaim.new_price) = $event)),
                      disabled: "",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.new_price]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formClaim.object === 'Rembourssement')
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _cache[59] || (_cache[59] = _createElementVNode("label", { for: "price_remb" }, "Nouveau Prix", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "price_remb",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formClaim.new_price_remb) = $event)),
                      disabled: "",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.new_price_remb]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(
                _ctx.formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              )
              }, [
                _cache[60] || (_cache[60] = _createElementVNode("label", { for: "city" }, "Ville", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "city",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formClaim.city_name) = $event)),
                  disabled: "",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.formClaim.city_name]
                ])
              ], 2),
              (_ctx.formClaim.object === 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _cache[61] || (_cache[61] = _createElementVNode("label", { for: "adresse" }, "Adresse", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      id: "adresse",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formClaim.adresse) = $event)),
                      rows: "3",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.adresse]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(
                _ctx.formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              )
              }, [
                _cache[62] || (_cache[62] = _createElementVNode("label", { for: "comment" }, "Commentaire", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "comment",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formClaim.msg) = $event)),
                  rows: "3",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.formClaim.msg]
                ])
              ], 2),
              (_ctx.formClaim.object === 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[63] || (_cache[63] = _createElementVNode("label", { for: "new_receiver" }, "Nouveau Client", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "new_receiver",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formClaim.new_receiver) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formClaim.new_receiver]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _cache[64] || (_cache[64] = _createElementVNode("label", { for: "new_phone" }, "Téléphone", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "new_phone",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formClaim.new_phone) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formClaim.new_phone]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _cache[66] || (_cache[66] = _createElementVNode("button", {
              type: "button",
              class: "ads-btn-outline transition fw-medium",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.traitClaim && _ctx.traitClaim(...args))),
              class: "ads-btn-primary border-0 transition fw-medium"
            }, " Traiter la réclamation ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[75] || (_cache[75] = _createStaticVNode("<div class=\"modal-header ads-modal-header\" data-v-9a73b940><div class=\"d-flex align-items-center\" data-v-9a73b940><span class=\"ads-modal-icon\" data-v-9a73b940><i class=\"ph ph-pen\" data-v-9a73b940></i></span><h5 class=\"modal-title ms-12 mb-0\" data-v-9a73b940>Changer objet</h5></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-9a73b940></button></div>", 1)),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("form", {
              onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editObjectClaim && _ctx.editObjectClaim(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_64, [
                _cache[68] || (_cache[68] = _createElementVNode("label", { for: "type" }, "Type de réclamation", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formObject.new_object) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectsClaim, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option
                    }, _toDisplayString(option.name), 9, _hoisted_65))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.formObject.new_object]
                ])
              ]),
              (_ctx.formObject.new_object?.name === 'Changement de prix')
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _cache[69] || (_cache[69] = _createElementVNode("label", { for: "price" }, "Nouveau prix *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "price",
                      type: "number",
                      min: "0",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formObject.price) = $event)),
                      placeholder: "Nouveau prix *",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formObject.price]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formObject.new_object?.name === 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[70] || (_cache[70] = _createElementVNode("label", { for: "adresse" }, "Nouvelle Adresse", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "adresse",
                        rows: "2",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formObject.adresse) = $event)),
                        placeholder: "Nouvelle Adresse",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formObject.adresse]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _cache[71] || (_cache[71] = _createElementVNode("label", { for: "receiver" }, "Nouveau Destinataire", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "receiver",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formObject.reciever) = $event)),
                        placeholder: "Nouveau Destinataire",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formObject.reciever]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _cache[72] || (_cache[72] = _createElementVNode("label", { for: "phone" }, "Nouveau Numéro Téléphone", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "phone",
                        name: "Téléphone",
                        type: "text",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formObject.phone) = $event)),
                        placeholder: "Nouveau Numéro Téléphone",
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.formObject.phone]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_70, [
                _cache[73] || (_cache[73] = _createElementVNode("label", { for: "msg" }, "Message *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "msg",
                  rows: "2",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formObject.msg) = $event)),
                  placeholder: "Message *",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.formObject.msg]
                ])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _cache[74] || (_cache[74] = _createElementVNode("button", {
              type: "button",
              class: "ads-btn-outline transition fw-medium",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.editObjectClaim && _ctx.editObjectClaim(...args))),
              class: "ads-btn-primary border-0 transition fw-medium"
            }, " Traiter la réclamation ")
          ])
        ])
      ])
    ])
  ], 64))
}